import React from "react";
import styled from "styled-components";
import {useUser} from "../../contexts/user";
import Follow from "./Follow";
import SubscriptionForm from "./SubscriptionForm";
import {logEvent} from "../../utils/analytics";

const FooterLayout = styled.footer`
  overflow: hidden;
  background: #1e1e1e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 480px) {
    overflow: hidden;
    padding-bottom: 2rem;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const FooterInner = styled.div`
  display: flex;
  font-family: "Inter", sans-serif !important;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
  padding-bottom: 40px;
  margin-left: 0;

  .newsletter-form {
    align-items: center !important;
  }
  .test {
    display: flex;
    flex-direction: row-reverse;
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
`;

const FooterItems = styled.div`
  text-align: center;
  margin-top: 40px;
  @media (min-width: 576px) {
    flex: 0 0 50%;
  }
  @media (min-width: 768px) {
    flex: auto;
    text-align: left;
    margin: 0 15px;
  }
  @media (min-width: 1200px) {
    margin: 0 10px;
  }
  @media (min-width: 1467px) {
    margin: 0 30px;
  }
`;

const FooterHeadings = styled.h2`
  font-family: "HackerNoon", sans-serif;
  margin: 0;
  line-height: 1;
  font-size: 24px;
  line-height: 25px;
  font-weight: 400;
  margin-top: 15px;
  margin-bottom: 30px;
  a {
    color: ${({color}) => (color ? color : "#00ff00")};
  }
`;

const FooterList = styled.ul`
  color: #ffffff;
  margin: 10px 0 0;
  padding: 0;
  line-height: 20.8px;
`;

const FooterListItem = styled.li`
  list-style: none;
  margin-top: 10px;
  margin-bottom: 15px;
  font-size: 16px;
  color: #e5e7eb;
  font-family: "Inter", sans-serif !important;
  @media (max-width: 550px) {
    font-size: 12px;
  }
`;

const FancySpan = styled.span`
  text-decoration: none;
  padding-bottom: 2px;
  color: inherit;
  font-size: inherit;
  line-height: 21px;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 0;
    height: 2px;
    background-color: #00ff00;
    transition: all 0.4s ease;
  }
  &:hover {
    &::before {
      width: 100%;
    }
  }
`;

const FooterGroups = styled.div`
  order: 2;
  display: grid;
  margin: 0 auto;
  grid-template-columns: 170px 170px;
  gap: 15px 10px;
  order: 1;

  @media screen and (max-width: 480px) {
    grid-template-columns: 150px 150px;
  }

  @media (min-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    grid-template-columns: 45% 45%;
  }

  @media (min-width: 1350px) {
    flex: 0 0 56%;
  }
  @media (min-width: 1467px) {
    flex: auto;
  }
`;

const FooterNewsletter = styled.div`
  order: 1;
  max-width: 96vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;

  h2 {
    text-align: center;
    @media (max-width: 370px) {
      font-size: 3.3vw !important;
    }
  }

  .footer-subheading {
    text-align: center;
    margin-bottom: 5px;
    font-size: 1.4rem !important;
    font-weight: 900;
    @media (max-width: 576px) {
      font-size: 1.2rem !important;
    }
    @media (max-width: 400px) {
      font-size: 2.8vw !important;
    }
  }

  @media (min-width: 768px) {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: 1350px) {
    order: 2;
    flex: 0 0 44%;
    margin-bottom: 0;
  }
  @media (min-width: 1467px) {
    margin-right: 30px;
    flex: auto;
  }
`;

const StyledFollow = styled.div`
  display: flex;
  justify-content: start;
  margin-top: 15px;
  margin-bottom: 15px;
  width: fit-content;
  img {
    filter: grayscale(100%) contrast(160%);
  }

  @media (max-width: 581px) {
    margin: 0 0;
    margin-top: 25px;

    div {
      margin: 0px;
    }

    a {
      padding: 3px !important;
      background: none;
      margin: 1px;
      img {
        width: 5.5vw;
        height: 5.5vw;
      }
    }
  }
`;

const FotterBottom = styled.div`
  width: 100%;
  height: fit-content;
  color: #e5e7eb;
  background: #1e1e1e;
  border-top: 1px solid #e5e7eb;
  margin-top: 30px;
  padding-top: 20px;
  span {
    width: 100%;
  }

  overflow: hidden;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  @media (max-width: 581px) {
    font-size: 2vw;
    height: 30px;
    flex-direction: column;
    height: 100%;
  }

  h2 {
    color: #00ff00;
    font-size: 1.6rem;
    font-family: "HackerNoon", sans-serif;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin: 0 0 10px 0;
    img {
      margin-right: 10px;
    }
  }
`;
const Mobile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 30px 0;
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
  }
  button {
    background: #e5e7eb;
    color: #1e1e1e;
    font-size: 12px;
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    font-family: "Inter", sans-serif !important;
    @media (max-width: 500px) {
      justify-content: center;
      margin-bottom: 10px;
    }
    :hover {
      background: #d1d5db;
      cursor: pointer;
    }
    span {
      display: flex;
      flex-direction: column;
      text-align: left;
    }
    .store {
      font-size: 18px;
      font-weight: bold;
    }
    img {
      width: 30px;
      height: 30px;
      margin-right: 20px;
    }
  }
  a {
    width: 48%;
    text-decoration: none;
    @media (max-width: 500px) {
      width: 90%;
    }
  }
`;

const FooterLink = ({href, children}) => {
  const logFooterLinkEvent = text => {
    logEvent("Footer Links", `${text} was clicked`, `The ${text} Footer link was clicked`);
  };
  return (
    <a style={{textDecoration: "none", color: "#E5E7EB"}} href={href}>
      <FancySpan onClick={() => logFooterLinkEvent(children)}>{children}</FancySpan>
    </a>
  );
};

const Footer = ({footerData = [], staticData = {}, colors}) => {
  const user = useUser() || {};
  let HnSocials = {
    twitter: "hackernoon",
    github: "hackernoon",
    youtube: "https://www.youtube.com/c/hackernoon",
    instagram: "hackernoon",
    facebook: "hackernoon",
  };

  return (
    <>
      {footerData.length > 0 && (
        <FooterLayout className="footer">
          <FooterInner>
            <div className="test">
              <FooterGroups>
                {footerData.map(section => (
                  <FooterItems key={Math.random()}>
                    <FooterHeadings>
                      <FooterLink href={section.headerUrl}>{section.header}</FooterLink>
                    </FooterHeadings>
                    <FooterList>
                      {section.sections.map((item, idx) => (
                        <FooterListItem key={Math.random()}>
                          <FooterLink href={item.url}>
                            {item.text.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
                          </FooterLink>
                        </FooterListItem>
                      ))}
                    </FooterList>
                  </FooterItems>
                ))}
              </FooterGroups>
              <FooterNewsletter>
                <SubscriptionForm colors={colors} staticData={staticData} />
                <Mobile>
                  <a href="https://apps.apple.com/us/app/hackernoon/id6447998105" target="_blank">
                    <button>
                      {" "}
                      <img src="/apple-store-black-logo.png" style={{width: "25px", height: "30px"}} />
                      <span>
                        Get our mobile app on <br />
                        <span className="store">App Store</span>{" "}
                      </span>
                    </button>
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.hackernoon.mobile" target="_blank">
                    <button>
                      <img src="/google-play-black-logo.png" style={{width: "25px", height: "30px"}} />{" "}
                      <span>
                        {" "}
                        Get our mobile app on <br />
                        <span className="store">Google Play</span>
                      </span>
                    </button>
                  </a>
                </Mobile>
                <span style={{fontSize: "12px", color: "white"}}>
                  © 2023 HackerNoon. All rights reserved - PO Box 2206, Edwards, Colorado 81632, USA
                </span>
              </FooterNewsletter>
            </div>
            <FotterBottom>
              <a style={{textDecoration: "none"}} href="https://hackernoon.com">
                <h2>
                  <img style={{width: "30px"}} src="/hn-green-logo-no-shadow.png" /> HACKERNOON
                </h2>
              </a>
              <StyledFollow>
                <Follow
                  colors={colors}
                  data={{
                    socialMedia: HnSocials,
                    digg: "https://digg.com/hacker-noon",
                    podcast: "https://podcast.hackernoon.com",
                    rss: "https://hackernoon.com/feed",
                    pinterest: "https://www.pinterest.com/hackernoon/",
                    googleNews: "https://news.google.com/search?q=hackernoon&hl=en-US&gl=US&ceid=US%3Aen",
                    giphy: "https://giphy.com/hackernoon",
                    reddit: "https://www.reddit.com/r/hackernoon/",
                    minds: "https://www.minds.com/hackernoon/",
                    mastodon: "https://mas.to/@hackernoon",
                    golden: "https://golden.com/wiki/HackerNoon-GE8X99N",
                    productHunt: "https://www.producthunt.com/products/hacker-noon",
                    bloomberg: "https://www.bloomberg.com/profile/company/1654159D:US",
                    figma: "https://www.figma.com/@hackernoon",
                    newsBreak: "https://www.newsbreak.com/hackernoon-560145",
                    npm: "https://www.npmjs.com/org/hackernoon",
                    viewBlock: "https://viewblock.io/arweave/address/X8se6ANj4C-gpP_JH0ZbtJJEpyHBr0XQA-crCpbZGak",
                    huggingFace: "https://huggingface.co/HackerNoon",
                    crunchBase: "https://www.crunchbase.com/organization/hackernoon",
                    linkedin: "https://www.linkedin.com/company/hackernoon/",
                  }}
                  nofollow
                />
              </StyledFollow>
            </FotterBottom>
          </FooterInner>
        </FooterLayout>
      )}
    </>
  );
};

export default Footer;
